<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0"><i class="fas fa-users"></i> Partnerek</h1>
      </div>
      <div class="ms-auto">
        <button
          v-if="[1, 5].includes(user.role_id)"
          class="btn btn-success btn-rounded px-4 rounded-pill"
          v-b-modal.addPartnerModal
        >
          <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új
          partner
        </button>
      </div>
    </div>
    <b-modal
      id="addPartnerModal"
      cancel-variant="default"
      @cancel="closeAddModal()"
      @hide="closeAddModal()"
      @ok="addPartner"
      ok-title="Létrehozás"
      cancel-title="Mégse"
      :ok-disabled="loading"
      @shown="$refs.add_partner_modal_name_input.focus()"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Új partner</h4>
        <a class="btn-close" @click="closeAddModal()"></a>
      </template>
      <form
        @submit.prevent="addPartner()"
        ref="partner_modal_form"
        v-if="loading == false"
      >
        <div class="form-group">
          <label class="form-label">Név:</label>
          <input
            ref="add_partner_modal_name_input"
            class="form-control"
            :class="{ 'is-invalid': errors.name }"
            type="text"
            v-model="partner.name"
            required
          />
          <div v-if="errors.name" class="invalid-feedback d-block">
            {{ errors.name[0] }}
          </div>
        </div>
        <div class="form-group mt-2">
          <label class="form-label">Levelezési cím:</label>
          <input
            class="form-control"
            :class="{ 'is-invalid': errors.site_address }"
            type="text"
            v-model="partner.site_address"
          />
          <div v-if="errors.site_address" class="invalid-feedback d-block">
            {{ errors.site_address[0] }}
          </div>
        </div>
        <div class="form-group mt-2">
          <label class="form-label">Adószám:</label>
          <masked-input
            pattern="11111111-1-11"
            class="form-control"
            placeholder="99999999-9-99"
            :class="{ 'is-invalid': errors.vat_number }"
            type="text"
            v-model="partner.vat_number"
          ></masked-input>
          <div v-if="errors.vat_number" class="invalid-feedback d-block">
            {{ errors.vat_number[0] }}
          </div>
        </div>
        <div class="form-group mt-3 d-none">
          <div class="input-group">
            <div class="input-group-text">
              <input
                type="checkbox"
                v-model="partner.can_add_users"
                :true-value="true"
                :false-value="false"
              />
            </div>
            <input
              disabled
              type="text"
              class="form-control"
              placeholder="Hozhat létre felhasználót"
            />
          </div>
        </div>
        <button type="submit" class="d-none"></button>
      </form>
      <Loading v-else title="Létrehozás"></Loading>
    </b-modal>
    <AddUserModal
      :partner_id="partner_id"
      title="Partner fiók létrehozása"
      :no_close="true"
      role_id="6"
    ></AddUserModal>
    <panel title="Partnerek">
      <Loading v-if="partners === false" title="Partnerek betöltése"></Loading>
      <NoRecords
        v-if="partners.length == 0"
        main_icon="fa fa-users"
        value="false"
        title="Nincsenek Partnerek"
        subtitle="hozzon létre újat"
      ></NoRecords>
      <vue-good-table
        v-if="partners.length != 0 && partners !== false"
        :columns="columns"
        :rows="partners"
        :lineNumbers="true"
        :search-options="{ enabled: false, placeholder: 'Keresés...' }"
        :pagination-options="{
          enabled: true,
          position: 'bottom',
          firstLabel: 'Első Lap',
          lastLabel: 'Utolsó Lap',
          nextLabel: 'következő',
          prevLabel: 'előző',
          rowsPerPageLabel: 'Sor oldalanként',
          ofLabel: '/',
          allLabel: 'Összes',
          infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <router-link
              :to="'partners/' + props.row.id + '/edit'"
              class="btn btn-primary mx-1"
              title="szerkesztés"
              ><i class="fa fa-pen"></i
            ></router-link>
            <button
              @click="deletePartner(props.row.id)"
              class="btn btn-danger mx-1"
              title="törlés"
            >
              <i class="fa fa-trash"></i>
            </button>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </panel>
  </div>
</template>

<script>
//:class="{'col-'+Math.floor(12/partner_colors.length()) : partner_colors !== false}"
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Partner from "../../apis/Partner";
import Confirmation from "../../apis/Confirmation";
import AddUserModal from "../../components/AddUserModal";

export default {
  components: {
    Loading,
    NoRecords,
    AddUserModal,
  },
  data() {
    return {
      columns: [
        {
          label: "Név",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Cím",
          field: "site_address",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a címek között",
          },
        },
        {
          label: "Adószám",
          field: "vat_number",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés az adószámokk között",
          },
        },
        {
          label: "Műveletek",
          field: "actions",
          width: "15%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end",
          hidden: true,
        },
      ],
      partners: false,
      partner: {
        can_add_users: false,
      },
      errors: [],
      loading: false,
      partner_id: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    user: {
      handler(val) {
        if (val && val.role_id == 1) {
          this.$set(this.columns[3], "hidden", false);
        } else {
          this.$set(this.columns[3], "hidden", true);
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.user.role_id == 1) {
      this.$set(this.columns[3], "hidden", false);
    }
  },
  created() {
    Partner.index().then((response) => {
      this.partners = response.data;
    });
  },
  methods: {
    closeAddModal() {
      this.partner = {
        can_add_users: false,
      };
      this.errors = [];
      this.$bvModal.hide("addPartnerModal");
    },
    addPartner(bvModalEvt) {
      this.loading = true;
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      Partner.add(this.partner)
        .then((response) => {
          this.partners.unshift(response.data);
          this.closeAddModal();
          this.partner_id = response.data.id;
          this.$bvModal.show("addUserModal");
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deletePartner(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Partner.delete(id)
            .then(() => {
              this.partners.splice(
                this.partners.map((partner) => partner.id).indexOf(id),
                1
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>
